// extracted by mini-css-extract-plugin
export default {"container":"TotalCount_container__SUR3B","bold":"TotalCount_bold__gUt7t","location":"TotalCount_location__sJWxF"};